<template>
  <div class="slotLevel">
    <el-form>
      <el-form-item :label="+data[index].level+'级代理'" v-for="(item,index) in data">
        <el-table :data="item.agentCustomerList">
          <el-table-column :prop="item.id" :label="item.name" v-for="item in nav"></el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'slotLevel',
  props: ['data','nav'],
}
</script>

<style>
.slotLevel{
  overflow-y: scroll;
  max-height: 700px;
}
.slotLevel .el-table{
  border-top: 1px solid #EBEEF5;
  border-left: 1px solid #EBEEF5;
}
.slotLevel .el-table td, .slotLevel .el-table th{
  border-right: 1px solid #EBEEF5;
}
</style>
